import React from "react";
import { Container } from "reactstrap";
import { PageTitleSetter } from "../../Common";

type Props = {
  src: string;
  alt: string;
  heading: string;
  description?: string;
};

const GenericErrorPage: React.FC<Props> = ({ src, alt, heading, description }) => (
  <Container className="d-flex flex-column align-items-center text-center">
    <PageTitleSetter title={heading} />
    <img src={src} width={300} alt={alt} />
    <h2 className="mt-2">{heading}</h2>
    {description ? <p className="mt-1">{description}</p> : null}
  </Container>
);

export default GenericErrorPage;
